
const STOPWORDS = [
    'i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', 'your', 'yours',
    'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', 'her', 'hers',
    'herself', 'it', 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves',
    'what', 'which', 'who', 'whom', 'this', 'that', 'these', 'those', 'am', 'is', 'are',
    'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does',
    'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until',
    'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into',
    'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down',
    'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here',
    'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more',
    'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so',
    'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', 'should', 'now'
];


// Function to remove stopwords from a dictionary of word counts
function removeStopwordsFromWordCounts(wordCounts) {
    // Iterate over the keys (words) in the dictionary
    Object.keys(wordCounts).forEach(word => {
        // Check if the word is a stopword
        if (STOPWORDS.includes(word.toLowerCase())) {
            // Remove the stopword from the dictionary
            delete wordCounts[word];
        }
    });
    return wordCounts;
}

function takeRandomSampleWithSeed(messages, sampleSize/* , seed */) {
    const sampledMessages = [];
    const numMessages = messages.length;

    // Set the seed for the random number generator
    // TODO: Enable Math.seedrandom function compatbility
    // Math.seedrandom(seed);

    // Generate random indices and select messages
    for (let i = 0; i < sampleSize; i++) {
        const randomIndex = Math.floor(Math.random() * numMessages);
        sampledMessages.push(messages[randomIndex]);
    }

    return sampledMessages;
}

export {
    removeStopwordsFromWordCounts,
    takeRandomSampleWithSeed,
};